var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(Number(_setup.type) === _setup.PLAN_TYPE.PERSON)?_c(_setup.addPersonEditNew,{attrs:{"mode":_setup.MODE_TYPE.COPY}}):(Number(_setup.type) === _setup.PLAN_TYPE.ENTER)?_c(_setup.addEnterEditNew,{attrs:{"mode":_setup.MODE_TYPE.COPY}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }